import React from 'react'
import useChargePoint from '../../hooks/useChargePoint';

export interface NbChargePointStationProps {
    stationId?: string;
}

export default function NbChargePointStation({stationId}: NbChargePointStationProps) {

    const {getAllBorneQuery: {isLoading, isError, data}} = useChargePoint({
        stationId: stationId
    })

    if (isLoading){
        return <>..</>
    }

    if (isError){
        return <>-</>
    }



  return (
    <>
      {data?.pagination.total_count}
    </>
  )
}
